import { Box } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import NavBar from '../../components/navbar/navbar';
import { cultura } from '../../utils/data';
import HomeCard from '../../components/homecard/homecard';

const Culture: React.FC = () => {
    const navigate = useNavigate();

    const handleCardClick = (id: number) => {
        navigate("/article", {
            state: { id: id },
        });
    };

    const renderCultureArticles = () => {
        return cultura.map((item) => (
            <HomeCard data={item} handleClick={handleCardClick}/>
        ));
    };

    return (
        <Box>
            <NavBar active="cultura"/>
            <Box m={5}>
                {renderCultureArticles()}
            </Box>
        </Box>
    )
}

export default Culture;